const LOCATIONS_COOKIE = "WAREHOUSEDELIVERY_WHS";
const MEMBERSHIP_ID_COOKIE = "wcMember";
const STORELOCATION_COOKIE = "STORELOCATION";
const AKAMAI_COOKIE = "client-zip-short";
const ZIPCODE_QUERY_PARAM = "zipcode=";
const SAMEDAYLINK = "sameday.costco";
const FALLBACK_SEARCH_PAGE_PREFIX = "/s?";
const FALLBACK_CATEGORY_LINK_PREFIX = "/c/";
export {
  AKAMAI_COOKIE,
  FALLBACK_CATEGORY_LINK_PREFIX,
  FALLBACK_SEARCH_PAGE_PREFIX,
  LOCATIONS_COOKIE,
  MEMBERSHIP_ID_COOKIE,
  SAMEDAYLINK,
  STORELOCATION_COOKIE,
  ZIPCODE_QUERY_PARAM
};
